import { Node, mergeAttributes } from '@tiptap/core';
var TableHeader = Node.create({
  name: 'tableHeader',
  addOptions: function addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  content: 'block+',
  addAttributes: function addAttributes() {
    return {
      colspan: {
        default: 1
      },
      rowspan: {
        default: 1
      },
      colwidth: {
        default: null,
        parseHTML: function parseHTML(element) {
          var colwidth = element.getAttribute('colwidth');
          var value = colwidth ? [parseInt(colwidth, 10)] : null;
          return value;
        }
      }
    };
  },
  tableRole: 'header_cell',
  isolating: true,
  parseHTML: function parseHTML() {
    return [{
      tag: 'th'
    }];
  },
  renderHTML: function renderHTML(_ref) {
    var HTMLAttributes = _ref.HTMLAttributes;
    return ['th', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  }
});
export { TableHeader, TableHeader as default };